import ThreeDPEducation from "@/components/AthleteProfileEducation/threeDP/ThreeDPEducation";
import { useSearchParams } from "react-router-dom";

const ThreeDPEducationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isStandAlone = searchParams.has("standAlone");
  const closeOnBack = !!searchParams.get("from");
  return <ThreeDPEducation isStandAlone={isStandAlone} closeOnBack={closeOnBack} />;
};

export default ThreeDPEducationPage;
